module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step_2_background-9e393fa4d072a12f704162f914c04bc4.svg";